import {
  LoadingManager,
  Material,
  Group,
  MaterialCreator,
  LoaderUtils,
  FileLoader,
  Vector3,
  TextureLoader,
  BufferAttribute,
  BufferGeometry,
  Color,
  Vector2,
  Object3D,
  DoubleSide,
  AmbientLight,
  PointLight,
  SpotLight,
  Mesh,
  SphereBufferGeometry,
  MeshBasicMaterial,
  BackSide,
  VertexColors,
  Scene,
  BoxBufferGeometry,
  CylinderBufferGeometry,
  Float32BufferAttribute,
  MeshPhongMaterial,
  DefaultLoadingManager,
  OrbitControls,
} from 'three';
import { exec } from 'child_process';

// https://github.com/mrdoob/three.js/blob/master/examples/js/loaders/OBJLoader.js

export class VRMLLoader {
  constructor(manager?: LoadingManager) {
    this.manager = undefined ? manager : DefaultLoadingManager;
    // console.log('manager: ', this.manager);
  }
  manager: LoadingManager;
  materials: Material[];
  path: string;
  resourcePath: string;

  // for IndexedFaceSet support
  isRecordingPoints = false;
  isRecordingFaces = false;
  points = [];
  indexes = [];

  // for Background support
  isRecordingAngles = false;
  isRecordingColors = false;
  angles = [];
  colors = [];

  recordingFieldname: string | null;

  crossOrigin = 'anonymous';

  lines: string[];
  defines = {};
  index = [];
  float_pattern = /(\b|\-|\+)([\d\.e]+)/;
  float2_pattern = /([\d\.\+\-e]+)\s+([\d\.\+\-e]+)/g;
  float3_pattern = /([\d\.\+\-e]+)\s+([\d\.\+\-e]+)\s+([\d\.\+\-e]+)/g;

  textureLoader = new TextureLoader(this.manager);
  scene: Scene;
  load(
    url: string,
    onLoad: (scene: Scene) => void,
    onProgress?: (event: ProgressEvent) => void,
    onError?: (event: ErrorEvent) => void,
  ): void {
    let path =
      this.path === undefined ? LoaderUtils.extractUrlBase(url) : this.path;
    let loader = new FileLoader(this.manager);
    loader.setPath(this.path);
    loader.load(
      url,
      text => {
        // console.log('data: ', text);
        // console.log('the scene', this.parse(text, path));
        onLoad(this.parse(text, path));
      },
      onProgress,
      onError,
    );
  }

  setPath(value: string): void {
    this.path = value;
    // let geometry = Object.create(BufferGeometry.prototype)
  }

  parse(data, path: string): Scene {
    console.log('run parse');
    // console.log('data: ', data);
    this.textureLoader
      .setPath(this.resourcePath || path)
      .setCrossOrigin(this.crossOrigin);
    // console.log('texture: ', this.textureLoader);
    this.scene = new Scene();
    this.lines = data.split('\n');
    // console.log('lines: ', this.lines);

    for (let i = this.lines.length - 1; i > -1; i--) {
      let line = this.lines[i];

      line = line.replace(/(#.*)/, '');
      if (/{.*[{\[]/.test(line)) {
        let parts = line
          .split('{')
          .join('{\n')
          .split('\n');
        // parts.unshift(1);
        // parts.unshift(i);
        let part: [number, number, ...string[]] = [1, i, ...parts];
        console.log('parts: ', parts);
        this.lines.splice.apply(this.lines, part);
      } else if (/\].*}/.test(line)) {
        // split lines with ]..}
        let parts = line
          .split(']')
          .join(']\n')
          .split('\n');
        // parts.unshift( 1 );
        // parts.unshift( i );
        let part: [number, number, ...string[]] = [1, i, ...parts];
        console.log('parts: ', parts);
        this.lines.splice.apply(this.lines, part);
      }

      if (/}.*}/.test(line)) {
        // split lines with }..}
        let parts = line
          .split('}')
          .join('}\n')
          .split('\n');
        let part: [number, number, ...string[]] = [1, i, ...parts];
        // parts.unshift(1);
        // parts.unshift(i);
        console.log('parts: ', parts);
        this.lines.splice.apply(this.lines, part);
      }

      if (/^\b[^\s]+\b$/.test(line.trim())) {
        this.lines[i + 1] = line + ' ' + this.lines[i + 1].trim();
        this.lines.splice(i, 1);
      } else if (
        line.indexOf('coord') > -1 &&
        line.indexOf('[') < 0 &&
        line.indexOf('{') < 0
      ) {
        this.lines[i] += 'Coordinate {}';
      }
    }
    // console.log('lines: ', this.lines);
    let header = this.lines.shift();
    // console.log('header: ', header);

    if (/V1.0/.exec(header)) {
      console.warn('THREE.VRMLLoader: V1.0 not supported yet.');
    } else if (/V2.0/.exec(header)) {
      this.parseV2(this.lines, this.scene);
    }
    return this.scene;
    // return new Group();
  }

  setResuorcePath(value: string): void {
    this.resourcePath = value;
  }
  setCrossOrigin(value: string): void {
    this.crossOrigin = value;
  }

  setMaterials(materials: MaterialCreator): void {}
  _createParserState(): any {}
  /**
   * Vertically paints the faces interpolating between the
   * specified colors at the specified angels. This is used for the Background
   * node, but could be applied to other nodes with multiple faces as well.
   *
   * When used with the Background node, default is directionIsDown is true if
   * interpolating the skyColor down from the Zenith. When interpolationg up from
   * the Nadir i.e. interpolating the groundColor, the directionIsDown is false.
   *
   * The first angle is never specified, it is the Zenith (0 rad). Angles are specified
   * in radians. The geometry is thought a sphere, but could be anything. The color interpolation
   * is linear along the Y axis in any case.
   *
   * You must specify one more color than you have angles at the beginning of the colors array.
   * This is the color of the Zenith (the top of the shape).
   *
   * @param geometry geometry
   * @param radius radius
   * @param angles angles
   * @param colors colors
   * @param boolean topDown Whether to work top down or bottom up.
   */
  private parseV2(lines, scene) {
    console.log('run parseV2');
    this.parseNode(this.getTree(lines), scene);
    // console.log('defines', this.defines['deur']);
  }
  private paintFaces(
    geometry: BufferGeometry,
    radius: number,
    angles,
    colors,
    topDown: boolean,
  ) {
    let direction = topDown === true ? 1 : -1;
    let coord = [],
      A = new Vector2(),
      B = new Vector2(),
      applyColor = false;
    for (let k = 0; k < angles.length; k++) {
      let vec = {
        x: direction * (Math.cos(angles[k]) * radius),
        y: direction * (Math.sin(angles[k]) * radius),
      };
      coord.push(vec);
    }
    let index = geometry.index;
    let positionAttribute = geometry.attributes.position;
    let colorAttribute = new BufferAttribute(
      new Float32Array(geometry.attributes.position.count * 3),
      3,
    );
    let position = new Vector3();
    let color = new Color();

    for (let i = 0; i < index.count; i++) {
      let vertexIndex = index.getX(i);
      position.fromBufferAttribute(
        <BufferAttribute>positionAttribute,
        vertexIndex,
      );
      for (let j = 0; j < colors.length; j++) {
        if (j === 0) {
          A.x = 0;
          A.y = topDown === true ? radius : -1 * radius;
        } else {
          A.x = coord[j - 1].x;
          A.y = coord[j - 1].y;
        }
        B = coord[j];
        if (B !== undefined) {
          applyColor =
            topDown === true
              ? position.y <= A.y && position.y > B.y
              : position.y >= A.y && position.y < B.y;
          if (applyColor === true) {
            let aColor = colors[j];
            let bColor = colors[j + 1];
            let t = Math.abs(position.y - A.y) / (A.y - B.y);
            color.copy(aColor).lerp(bColor, t);
            colorAttribute.setXYZ(vertexIndex, color.r, color.g, color.b);
          } else {
            let colorIndex = topDown === true ? colors.length - 1 : 0;
            let c = colors[colorIndex];
            colorAttribute.setXYZ(vertexIndex, c.r, c.g, c.b);
          }
        }
      }
    }
    geometry.addAttribute('color', colorAttribute);
  }
  private parseProperty(node, line: string) {
    // console.log('reg');
    let parts = [],
      part,
      property = {},
      fieldName;
    // /**
    //  * Expression for matching relevant information, such as a name or value, but not the separators
    //  * @type {RegExp}
    //  */
    let regex = /[^\s,\[\]]+/g;
    let point;

    while (null !== (part = regex.exec(line))) {
      parts.push(part[0]);
    }
    fieldName = parts[0];
    switch (fieldName) {
      case 'skyAngle':
      case 'groundAngle':
        this.recordingFieldname = fieldName;
        this.isRecordingAngles = true;
        this.angles = [];
        break;
      case 'color':
      case 'skyColor':
      case 'groundColor':
        this.recordingFieldname = fieldName;
        this.isRecordingColors = true;
        this.colors = [];
        break;
      case 'point':
      case 'vector':
        this.recordingFieldname = fieldName;
        this.isRecordingPoints = true;
        this.points = [];
        break;
      case 'colorIndex':
      case 'coordIndex':
      case 'normalIndex':
      case 'texCoordIndex':
        this.recordingFieldname = fieldName;
        this.isRecordingFaces = true;
        this.indexes = [];
        break;
    }

    if (this.isRecordingFaces) {
      if (parts.length > 0) {
        for (let ind = 0; ind > parts.length; ind++) {
          if (!/(-?\d+)/.test(parts[ind])) {
            continue;
          }
          if (parts[ind] === '-1') {
            if (this.index.length > 0) {
              this.indexes.push(this.index);
            }
            this.index = [];
          } else {
            this.index.push(parseInt(parts[ind]));
          }
        }
      }

      if (/]/.exec(line)) {
        if (this.index.length > 0) {
          this.indexes.push(this.index);
        }
        this.index = [];
        this.isRecordingFaces = false;
        node[this.recordingFieldname] = this.indexes;
      }
    } else if (this.isRecordingPoints) {
      if (node.nodeType === 'Coordinate') {
        while (null !== (parts = this.float3_pattern.exec(line))) {
          point = {
            x: parseFloat(parts[1]),
            y: parseFloat(parts[2]),
            z: parseFloat(parts[3]),
          };
          this.points.push(point);
        }
      }
      if (node.nodeType === 'Normal') {
        while (null !== (parts = this.float3_pattern.exec(line))) {
          point = {
            x: parseFloat(parts[1]),
            y: parseFloat(parts[2]),
            z: parseFloat(parts[3]),
          };
          this.points.push(point);
        }
      }
      if (node.nodeType === 'TextureCoordinate') {
        while (null !== (parts = this.float2_pattern.exec(line))) {
          point = {
            x: parseFloat(parts[1]),
            y: parseFloat(parts[2]),
          };
          this.points.push(point);
        }
      }

      if (/]/.exec(line)) {
        this.isRecordingPoints = false;
        node.points = this.points;
      }
    } else if (this.isRecordingAngles) {
      if (parts.length > 0) {
        for (let ind = 0; ind < parts.length; ind++) {
          if (!this.float_pattern.test(parts[ind])) {
            continue;
          }
          this.angles.push(parseFloat(parts[ind]));
        }
      }
      if (/]/.exec(line)) {
        this.isRecordingAngles = false;
        node[this.recordingFieldname] = this.angles;
      }
    } else if (this.isRecordingColors) {
      while (null !== (parts = this.float3_pattern.exec(line))) {
        let color = {
          r: parseFloat(parts[1]),
          g: parseFloat(parts[2]),
          b: parseFloat(parts[3]),
        };
        this.colors.push(color);
      }

      if (/]/.exec(line)) {
        this.isRecordingColors = false;
        node[this.recordingFieldname] = this.colors;
      }
    } else if (parts[parts.length - 1] !== 'NULL' && fieldName !== 'children') {
      switch (fieldName) {
        case 'duffuseColor':
        case 'emissiveColor':
        case 'specularColor':
        case 'color':
          if (parts.length !== 4) {
            console.warn(
              'Three.VRMLLoader: Invalid color format detected for %s',
              fieldName,
            );
            break;
          }
          property = {
            r: parseFloat(parts[1]),
            g: parseFloat(parts[2]),
            b: parseFloat(parts[3]),
          };
          break;
        case 'location':
        case 'direction':
        case 'translation':
        case 'scale':
        case 'size':
          if (parts.length !== 4) {
            console.warn(
              'THREE.VRMLLoader: Invalid vector format detected for %s',
              fieldName,
            );
            break;
          }
          property = {
            x: parseFloat(parts[1]),
            y: parseFloat(parts[2]),
            z: parseFloat(parts[3]),
          };
          break;
        case 'intensity':
        case 'cutOffAngle':
        case 'radius':
        case 'topRadius':
        case 'height':
        case 'transparency':
        case 'shininess':
        case 'ambientIntensity':
        case 'creaseAngle':
          if (parts.length !== 2) {
            console.warn(
              'THREE.VRMLLoader: Invalid single float value specification detected for %s.',
              fieldName,
            );
            break;
          }
          property = parseFloat(parts[1]);
          break;
        case 'rotation':
          if (parts.length !== 5) {
            console.warn(
              'THREE.VEMLLoader: Invalid quaternion format detected for %s.',
              fieldName,
            );
            break;
          }
          property = parseFloat(parts[1]);
          break;
        case 'rotation':
          if (parts.length !== 5) {
            console.warn(
              'THREE.VRMLLoader: Invalid quaternion format detected for %s.',
              fieldName,
            );
            break;
          }
          property = {
            x: parseFloat(parts[1]),
            y: parseFloat(parts[2]),
            z: parseFloat(parts[3]),
            w: parseFloat(parts[4]),
          };
          break;
        case 'on':
        case 'ccw':
        case 'solid':
        case 'colorPerVertex':
        case 'convex':
          if (parts.length !== 2) {
            console.warn(
              'THREE.VRMLLoader: Invalid format detected for %s.',
              fieldName,
            );
            break;
          }
          property = parts[1] === 'TRUE' ? true : false;
          break;
      }
      node[fieldName] = property;
    }
    return property;
  }

  private getTree(lines: string[]) {
    interface BlockType {
      nodeType: string;
      string: string;
      parent: any;
      children: any;
      comment: string;
    }
    console.log('run getTree');
    // console.log('lines: ', lines);
    let tree = { string: 'Scene', children: [] };
    let current = tree;
    let matches;
    let specification;

    for (let i = 0; i < lines.length; i++) {
      // console.log('tree: ', tree);
      let comment = '';
      let line = lines[i];
      if (null !== /^\s+?$/g.exec(line)) {
        // console.log('reg1');
        continue;
      }
      line = line.trim();
      if (line === '') {
        // console.log('current line: ', lines[i]);
        // console.log('reg2: ', i);
        continue;
      }

      if (/#/.exec(line)) {
        // console.log('reg3');
        let parts = line.split('#');
        // console.log('parts: ', parts );
        line = parts[0];
        comment = parts[1];
      }

      if ((matches = /([^\s]*){1}(?:\s+)?{/.exec(line))) {
        // console.log('reg4');
        let block = {
          nodeType: matches[1],
          string: line,
          parent: current,
          children: [],
          comment: comment,
        };
        current.children.push(block);
        // console.log('children: ', current);
        // console.log('tree1: ', tree);
        current = block;
        // console.log('block: ', block);
        // console.log('current: ',current);
        // let current1 = block; // #TODO: can not get the current.parent in ts

        if (/}/.exec(line)) {
          // console.log('reg');
          specification = /{(.*)}/.exec(line)[1];
          block.children.push(specification);
          this.parseProperty(current, specification);
          current = (current as BlockType).parent;
        }
        // tree.children.push(block);
      } else if (/}/.exec(line)) {
        // console.log('reg5');
        // #TODO: can not get the current.parent in ts
        // current = current.parent;
        current = (current as BlockType).parent;
      } else if (line !== '') {
        console.log('reg6');
        this.parseProperty(current, line);
        current.children.push(line);
      }
    }
    console.log('tree: ', tree);
    return tree;
  }

  parseNode(data, parent) {
    console.log('run parseNode');
    // console.log('tree: ', data);
    // console.log(data.coordIndex);
    // let object: AmbientLight | PointLight | SpotLight | Object3D;
    let object;
    if (typeof data === 'string') {
      if (/USE/.exec(data)) {
        let defineKey = /USE\s+?([^\s]+)/.exec(data)[1];
        if (undefined === this.defines[defineKey]) {
          console.warn('THREE.VRMLLoader: %s is not defined', defineKey);
        } else {
          if (/appearance/.exec(data) && defineKey) {
            parent.material = this.defines[defineKey].clone();
          } else if (/geometry/.exec(data) && defineKey) {
            parent.geometry = this.defines[defineKey].clone();
            if (
              this.defines[defineKey].solid !== undefined &&
              this.defines[defineKey].solid === false
            ) {
              parent.geometry.solid = false;
              parent.material.side = DoubleSide;
            }
          } else if (defineKey) {
            object = this.defines[defineKey].clone();
            parent.add(object);
          }
        }
      }
      return;
    }
    object = parent;
    if (
      data.string.indexOf('AmbientLight') > -1 &&
      data.nodeType === 'PointLight'
    ) {
      data.nodeType = 'AmbientLight';
    }
    let l_visible = data.on !== undefined ? data.on : true;
    let l_intensity = data.intensity !== undefined ? data.intensity : 1;
    let l_color = new Color();

    if (data.color) {
      l_color.copy(data.color);
    }
    if (data.nodeType === 'AmbientLight') {
      object = new AmbientLight(l_color, l_intensity);
      object.visible = l_visible;
      parent.add(object);
    } else if (data.nodeType === 'PointLight') {
      let l_distance = 0;
      if (data.radius !== undefined && data.radius < 1000) {
        l_distance = data.radius;
      }
      object = new PointLight(l_color, l_intensity, l_distance);
      object.visible = l_visible;
      parent.add(object);
    } else if (data.nodeType === 'SpotLight') {
      let l_intensity = 1;
      let l_distance = 0;
      let l_angle = Math.PI / 3;
      let l_penumbra = 0;
      let l_visible = true;

      if (data.radius !== undefined && data.radius < 1000) {
        l_distance = data.radius;
      }
      if (data.cutOffAngle !== undefined) {
        l_angle = data.cutOffAngle;
      }
      object = new SpotLight(
        l_color,
        l_intensity,
        l_distance,
        l_angle,
        l_penumbra,
      );
      object.visible = l_visible;
      parent.add(object);
    } else if (data.nodeType === 'Transform' || data.nodeType === 'Group') {
      object = new Object3D();

      if (/DEF/.exec(data.string)) {
        object.name = /DEF\s+([^\s]+)/.exec(data.string)[1];
        this.defines[object.name] = object;
      }
      if (data.translation !== undefined) {
        let t = data.translation;
        object.position.set(t.x, t.y, t.z);
      }
      if (data.rotation !== undefined) {
        let r = data.rotation;
        object.quaternion.setFromAxisAngle(new Vector3(r.x, r.y, r.z), r.w);
      }
      if (data.scale !== undefined) {
        let s = data.scale;
        object.scale.set(s.x, s.y, s.z);
      }
      parent.add(object);
    } else if (data.nodeType === 'Shape') {
      object = new Mesh();
      if (/DEF/.exec(data.string)) {
        object.name = /DEF\s+([^\s]+)/.exec(data.string)[1];
        this.defines[object.name] = object;
      }
      parent.add(object);
    } else if (data.nodeType === 'Background') {
      let segments = 20;
      let radius = 2e4;
      let skyGeometry = new SphereBufferGeometry(radius, segments, segments);
      let skyMaterial = new MeshBasicMaterial({ fog: false, side: BackSide });

      if (data.skyColor.length > 1) {
        this.paintFaces(
          skyGeometry,
          radius,
          data.skyAngle,
          data.skyColor,
          true,
        );
        skyMaterial.vertexColors = VertexColors;
      } else {
        let color = data.skyColor[0];
        // r b g in origin three.js
        skyMaterial.color.setRGB(color.r, color.g, color.b);
      }
      this.scene.add(new Mesh(skyGeometry, skyMaterial));

      if (data.groundColor !== undefined) {
        radius = 1.2e4;
        let groundGeometry = new SphereBufferGeometry(
          radius,
          segments,
          segments,
          0,
          2 * Math.PI,
          0.5 * Math.PI,
          1.5 * Math.PI,
        );
        let groundMaterial = new MeshBasicMaterial({
          fog: false,
          side: BackSide,
          vertexColors: VertexColors,
        });
        this.paintFaces(
          groundGeometry,
          radius,
          data.groundAngle,
          data.groundColor,
          false,
        );
        this.scene.add(new Mesh(groundGeometry, groundMaterial));
      }
    } else if (/geometry/.exec(data.string)) {
      // console.log(data.nodeType);
      // console.log('geometry');
      if (data.nodeType === 'Box') {
        // console.log('Box');
        let s = data.size;
        parent.geometry = new BoxBufferGeometry(s.x, s.y, s.z);
      } else if (data.nodeType === 'Cylinder') {
        console.log('Cylinder');
        parent.geometry = new CylinderBufferGeometry(
          data.radius,
          data.radius,
          data.heigjt,
        );
      } else if (data.nodeType === 'Cone') {
        console.log('Cone');
        parent.geometry = new CylinderBufferGeometry(
          data.topRadius,
          data.bottomRadius,
          data.height,
        );
      } else if (data.nodeType === 'Sphere') {
        // console.log('Sphere');
        parent.geometry === new SphereBufferGeometry(data.radius);
      // } else if (data.nodeType === 'IndexedFaceSet') {
      } else if (data.nodeType === 'IndexedFaceSet1') {
        // console.log('data coordIndex', data.coordIndex);
        // console.log('IndexFaceSet');
        let geometry = new BufferGeometry();
        // console.log('geometry',geometry);
        let positions = [];
        let colors = [];
        let normals = [];
        let uvs = [];

        let position, color, normal, uv;
        let i, il, j, jl;

        for (i = 0, il = data.children.length; i < il; i++) {
          let child = data.children[i];

          // uvs
          if (child.nodeType === 'TextureCoordinate') {
            if (child.points) {
              for (j = 0, jl = child.points.length; j < jl; j++) {
                uv = child.points[j];
                uvs.push(uv.x, uv.y);
              }
            }
          }

          // normals
          if (child.nodeType === 'Normal') {
            if (child.points) {
              for (j = 0, jl = child.points.length; j < jl; j++) {
                normal = child.points[j];
                normals.push(normal.x, normal.y, normal.z);
              }
            }
          }

          // colors
          if (child.nodeType === 'Color') {
            if (child.color) {
              for (j = 0, jl = child.color.length; j < jl; j++) {
                color = child.color[j];
                colors.push(color.r, color.g, color.b);
              }
            }
          }

          // positions
          if (child.nodeType === 'Coordinate') {
            if (child.points) {
              for (j = 0, jl = child.points.length; j < jl; j++) {
                position = child.points[j];
                positions.push(position.x, position.y, position.z);
              }
            }

            if (child.string.indexOf('DEF') > -1) {
              let name = /DEF\s+([^\s]+)/.exec(child.string)[1];
              this.defines[name] = positions.slice(0);
            }

            if (child.string.indexOf('USE') > -1) {
              let defineKey = /USE\s+([^\s]+)/.exec(child.string)[1];
              positions = this.defines[defineKey];
            }
          }
        }

        if (data.coordIndex) {
          // if (false) {
          // console.log('data coorIndex:',data.coordIndex);
          let positionIndexes = data.coordIndex
            ? this.triangulateIndexArray(data.coordIndex, data.ccw)
            : [];
          let normalIndexes = data.normalIndex
            ? this.triangulateIndexArray(data.normalIndex, data.ccw)
            : positionIndexes;
          let colorIndexes = data.colorIndex
            ? this.triangulateIndexArray(data.texCoordIndex, data.ccw)
            : positionIndexes;
          let uvIndexes = data.texCoordIndex
            ? this.triangulateIndexArray(data.texCoordIndex, data.ccw)
            : positionIndexes;

          let newIndexes = [];
          let newPositions = [];
          let newNormals = [];
          let newColors = [];
          let newUvs = [];

          let pointMap = Object.create(null);

          for (i = 0; i < positionIndexes.length; i++) {
            let pointAttributes = [];
            let positionIndex = positionIndexes[i];
            let normalIndex = normalIndexes[i];
            let colorIndex = colorIndexes[i];
            let uvIndex = uvIndexes[i];

            let base = 10;

            pointAttributes.push(positionIndex.toString(base));
            if (normalIndex !== undefined) {
              pointAttributes.push(normalIndex.toString(base));
            }
            if (colorIndex !== undefined) {
              pointAttributes.push(colorIndex.toString(base));
            }
            if (uvIndex !== undefined) {
              pointAttributes.push(uvIndex.toString(base));
            }

            let pointId = pointAttributes.join('.');
            let newIndex = pointMap[pointId];

            if (newIndex === undefined) {
              newIndex = newPositions.length / 3;
              pointMap[pointId] = newIndex;

              newPositions.push(
                positions[positionIndex * 3],
                positions[positionIndex * 3 + 1],
                positions[positionIndex * 3 + 2],
              );

              if (normalIndex !== undefined && normals.length > 0) {
                newNormals.push(
                  normals[normalIndex * 3],
                  normals[normalIndex * 3 + 1],
                  normals[normalIndex * 3 + 2],
                );
              }

              if (colorIndex !== undefined && colors.length > 0) {
                newColors.push(
                  colors[colorIndex * 3],
                  colors[colorIndex * 3 + 1],
                  colors[colorIndex * 3 + 2],
                );
              }

              if (uvIndex !== undefined && uvs.length > 0) {
                newUvs.push(uvs[uvIndex * 2], uvs[uvIndex * 2 + 1]);
              }
            }

            newIndexes.push(newIndex);
          }

          positions = newPositions;
          normals = newNormals;
          colors = newColors;
          uvs = newUvs;

          geometry.setIndex(newIndexes);
        } else {
          // do not add dummy mesh to the scene
          parent.parent.remove(parent);
        }

        if (false === data.solid) {
          parent.material.side = DoubleSide;
        }
        // #TODO: Class BufferGeometry in ts does not have the attribute of solid
        // geometry.solid = data.solid;
        geometry.addAttribute(
          'position',
          new Float32BufferAttribute(position, 3),
        );

        if (colors.length > 0) {
          geometry.addAttribute('color', new Float32BufferAttribute(colors, 3));
          parent.material.VertexColors = VertexColors;
        }
        if (uvs.length > 0) {
          geometry.addAttribute('uv', new Float32BufferAttribute(uvs, 2));
        }
        if (normals.length > 0) {
          geometry.addAttribute(
            'normal',
            new Float32BufferAttribute(normal, 3),
          );
        } else {
          geometry = geometry.toNonIndexed();
          geometry.computeVertexNormals();
        }
        geometry.computeBoundingSphere();

        if (/DEF/.exec(data.string)) {
          geometry.name = /DEF ([^\s]+)/.exec(data.string)[1];
          this.defines[geometry.name] = geometry;
        }
        parent.geometry = geometry;
      }
      return;
    } else if (/appearance/.exec(data.string)) {
      for (let i = 0; i < data.children.length; i++) {
        let child = data.children[i];
        if (child.nodeType === 'Material') {
          let material = new MeshPhongMaterial();

          if (child.diffuseColor !== undefined) {
            let d = child.diffuseColor;
            material.color.setRGB(d.r, d.g, d.b);
          }

          if (child.emissiveColor !== undefined) {
            let e = child.emissiveColor;
            material.emissive.setRGB(e.r, e.g, e.b);
          }
          if (child.specularColor !== undefined) {
            let s = child.specularColor;
            material.specular.setRGB(s.r, s.g, s.b);
          }
          if (child.transparency !== undefined) {
            let t = child.transparency;
            material.opacity = Math.abs(1 - t);
            material.transparent = true;
          }
          if (/DEF/.exec(data.string)) {
            material.name = /DEF ([^\s]+)/.exec(data.string)[1];
            this.defines[material.name] = material;
          }
          parent.material = material;
        }
        if (child.nodeType === 'ImageTexture') {
          let textureName = /"([^"]+)"/.exec(child.children[0]);
          if (textureName) {
            parent.material.name = textureName[1];
            parent.material.map = this.textureLoader.load(textureName[1]);
          }
        }
      }
      return;
    }
    for (let i = 0, l = data.children.length; i < l; i++) {
      // console.log('i: ', i);
      // console.log('p');
      this.parseNode(data.children[i], object);
    }
  }

  private triangulateIndexArray(indexArray, ccw, colorPerVertex = true) {
    // #TODO: colorPerVertex has no default value in js?

    if (ccw === undefined) {
      ccw = true;
    }
    let triangulatedIndexArray = [];
    let skip = 0;

    for (let i = 0; i < indexArray.length; i++) {
      if (colorPerVertex === false) {
        let colorIndices = indexArray[i];
        for (let j = 0; j < colorIndices.length; j++) {
          let index = colorIndices[j];
          triangulatedIndexArray.push(index, index, index);
        }
      } else {
        let indexedFace = indexArray[i];
        skip = 0;

        while (indexedFace.length >= 3 && skip < indexedFace.length - 2) {
          let i1 = indexedFace[0];
          let i2 = indexedFace[skip + (ccw ? 1 : 2)];
          let i3 = indexedFace[skip + (ccw ? 2 : 1)];

          triangulatedIndexArray.push(i1, i2, i3);
          skip++;
        }
      }
    }
    return triangulatedIndexArray;
  }
}
